<template>
  <div class="index-component" v-iscroll>
    <div class="index-c">
      <div class="index-title">{{title}}</div>
      <div class="index-content">
        <div class="content-box cursor-pointer" v-for="item in contentDataNew" :key="item.mid" @click="openTile(item)">
          <div class="box-t" @mousemove="selected=item.mid" @mouseout="selected=0" :class="{'selected':selected===item.mid}">{{item.menu_name[0]}}</div>
          <div class="box-p">{{item.menu_name}}</div>
        </div>
        <div class="search-none" :class="cls === 'index'? 'search-none-index':'search-none-search'" v-show="contentDataNew.length === 0">
          <img class="search-noneImg" :src="dataNone">
          <p>{{cls === 'index' ? '暂无推送，请先使用吧' : '暂无查询结果，请换其它名试试吧'}}</p>
        </div>
      </div>
    </div>
    <div class="index-h" v-show="cls==='index'">
      <img :src="indexImg" class="indexImg">
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {indexImg, dataNone} from 'utils/imgUrl'
export default {
  data () {
    return {
      indexImg,
      dataNone,
      selected: 0
    }
  },
  props: {
    cls: {
      type: String,
      default: 'index'
    },
    contentData: {
      type: Array
    }
  },
  computed: {
    contentDataNew () {
      let res = (this.cls === 'index') ? this.contentData.slice(0, 6) : this.contentData
      return res
    },
    title () {
      return (this.cls === 'index') ? '猜你想看' : '查询结果'
    }
  },
  methods: {
    openTile (item) {
      this.$emit('chooseId', item.mid, item.menu_path, item.menu_name)
    }
  }
}
</script>
<style lang="less">
@import '~assets/style/mixin.less';
@import '~assets/style/variable.less';
.index-component {
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: relative;
}
.index-c {
  padding: 40px;
}
.index-title {
  font-size: @font-size-large;
  width: 826px;
  height: 40px;
  line-height: 40px;
  margin-left: 40px;
}
.search-none-search {
  height: 100%;
  position: absolute;
  top: 150%;
  left: 50%;
  transform: translateX(-50%);
}
.index-content {
  display: flex;
  flex-wrap: wrap;
  width: 876px;
  margin: 16px auto;
  .content-box {
    margin-left: 40px;
    margin-top: 15px;
    .flex-column-center;
    .box-t {
      width: 82px;
      height: 82px;
      border-radius: 8px;
      background: @color-theme;
      color: #fff;
      font-size: 44px;
      text-align: center;
      line-height: 82px;
      box-shadow: 0 1px 4px 0 rgba(204,204,204,0.50);
    }
    .selected {
      background: @color-theme-d;
      box-shadow: 0 3px 6px 0 rgba(153,153,153,0.50);
    }
    .box-p {
      width: 106px;
      height: 40px;
      line-height: 20px;
      font-size: @font-size-medium;
      text-overflow: ellipsis;
      color: #333;
      margin-top: 12px;
      text-align: center;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.index-h {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: linear-gradient(to bottom, #182972, #008BB6);
  .indexImg {
    width: 900px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexList.vue